import React from 'react'
import test_image from '@/img/tradly/listing-category.png'
import Image from 'next/image'

const SuperAdmin = () => {
  return (
    // component
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      {/* COntainer */}
      <div className="flex flex-col md:flex-row items-center justify-between  gap-8 md:gap-16 ">
        {/* Section 1 */}
        <div className="w-full h-auto  max-w-[400px]">
          {/* Title */}
          <h2 className="h2 mb-[70px] text-center md:text-start">SuperAdmin Panel</h2>
          {/* Section 1 content */}
          <div className=" flex flex-col gap-7 ">
            {/* 1 */}
            <div className="flex items-start justify-start gap-5  w-full">
              <div className=" flex-none h-10 w-10 rounded-full bg-[#F4F5F7]" />
              <div className=" grow space-y-2">
                <p className="text-[18px] leading-[32px]   font-semibold">Manage CMS</p>
                <p className="ext-[14px] leading-[22px] font-normal w-[97%]">
                  Control what you information you need when user signup, create multi vendor
                  accounts, add listings.
                </p>
              </div>
            </div>
            {/* 2 */}
            <div className="flex items-start justify-start gap-5  w-full">
              <div className=" flex-none h-10 w-10 rounded-full bg-[#F4F5F7]" />
              <div className=" grow space-y-2">
                <p className="text-[18px] leading-[32px]   font-semibold">Run Business</p>
                <p className="ext-[14px] leading-[22px] font-normal w-[98%]">
                  Quick Reports, Add Collections of Listings, Promotions, Discounts Coupons, Manage
                  users/accounts/listings, Finance Operations.
                </p>
              </div>
            </div>
            <div className="flex items-start justify-start gap-5  w-full">
              <div className=" flex-none h-10 w-10 rounded-full bg-[#F4F5F7]" />
              <div className=" grow space-y-2">
                <p className="text-[18px] leading-[32px]   font-semibold">Setup your Project</p>
                <p className="ext-[14px] leading-[22px] font-normal w-[95%]">
                  Customize emails, Payments, Shipments/Service, Revenue Model, Variants, etc
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 2 (Image box) */}
        <div className=" w-auto h-auto ">
          <img
            src={test_image}
            className="w-full max-w-3xl h-full object-container    shadow-custom"
          />
        </div>
      </div>
    </div>
  )
}

export default SuperAdmin
